import { rgba } from "polished";
import styled, { css } from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import radioButtonThemes from "./themes/index.js";
export const RadioButtonLabel = styled.label.withConfig({
    displayName: "styled__RadioButtonLabel",
    componentId: "sc-8cf55b7d-0"
})`
	color: ${({ theme  })=>theme.colors.grays.darker};
	cursor: pointer;
	${FontMixin({
    size: 'medium',
    height: 'medium',
    weight: 'light'
})}

	${({ $checked , theme  })=>$checked && css`
			&::after {
				background-color: ${theme.colors.status.info};
				border-radius: 50%;
				content: '';
				height: 10px;
				width: 10px;
				top: 50%;
				left: 4px;
				position: absolute;
				transform: translateY(-50%);
			}
		`}

	&:before {
		background-color: ${({ theme  })=>theme.colors.white.base};
		border-radius: 50%;
		content: '';
		height: 18px;
		width: 18px;
		left: 0;
		top: 50%;
		position: absolute;
		transform: translateY(-50%);
		border: 1px solid ${({ theme  })=>theme.colors.grays.base};
	}

	${({ $withCount  })=>$withCount && css`
			& {
				${FlexMixin({
        justify: 'space-between',
        align: 'center'
    })}
				width: 100%;
			}
		`}

	${({ $disabled , theme  })=>$disabled ? `
				color: ${rgba(theme.colors.grays.darker, 0.56)}
				` : ''}

	${({ theme , $hasError  })=>$hasError ? `
		color: ${theme.colors.status.error};
	` : ''}

	${radioButtonThemes('RadioButtonLabel')}
`;
export const RadioButtonInput = styled.input.withConfig({
    displayName: "styled__RadioButtonInput",
    componentId: "sc-8cf55b7d-1"
})`
	width: 18px;
	height: 0;
	appearance: none;

	&:focus + ${RadioButtonLabel}:before {
		border-color: ${({ theme  })=>theme.colors.primary.base};
	}

	${radioButtonThemes('RadioButtonInput')}
`;
export const RadioButtonLabelCount = styled.span.withConfig({
    displayName: "styled__RadioButtonLabelCount",
    componentId: "sc-8cf55b7d-2"
})`
	border-radius: 8px;
	padding: 2px 6px;
	background-color: ${({ theme  })=>theme.colors.grays.lighter};
	color: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    size: 'small',
    height: 'medium',
    weight: 'light'
})}
	margin-left: 8px;
	float: right;
`;
export const RadioButtonItemWrapper = styled.div.withConfig({
    displayName: "styled__RadioButtonItemWrapper",
    componentId: "sc-8cf55b7d-3"
})`
	${FlexMixin({
    justify: 'flex-start',
    align: 'center'
})}
	${FontMixin({
    size: 'base',
    height: 'base',
    weight: 'light'
})}
	position: relative;

	${({ $withCount  })=>$withCount && css`
			& {
				width: 100%;
			}
		`}

	${({ $variant  })=>$variant === 'default' && css`
			gap: 8px;
		`}

	${({ $variant , $extended  })=>$variant == 'button' && css`
			${RadioButtonInput} {
				-webkit-appearance: none;
				appearance: none;

				width: 0;
				border-radius: 4px;

				&:checked + ${RadioButtonLabel} {
					background-color: transparent;
					border: 2px solid #fff;
					border-radius: 4px;
					color: #fff;
				}

				&:focus + ${RadioButtonLabel} {
					border: 2px solid #fff;
					border-radius: 4px;
				}
			}

			${RadioButtonLabel} {
				display: inline-block;
				background-color: transparent;
				padding: 8px 16px;
				color: #fff;
				border: 2px solid transparent;
				border-radius: 4px;
				text-align: center;
				white-space: nowrap;

				&::before {
					display: none;
				}

				&::after {
					display: none;
				}

				&:hover {
					background-color: transparent;
					border: 2px solid #fff;
					border-radius: 4px;
				}
			}

			${$extended && css`
				flex: 1 1 50%;

				${RadioButtonLabel} {
					width: 100%;
				}
			`}
		`}
	${radioButtonThemes('RadioButtonItemWrapper')}
`;
export const RadioButtonRightContent = styled.span.withConfig({
    displayName: "styled__RadioButtonRightContent",
    componentId: "sc-8cf55b7d-4"
})`
	margin-left: 8px;
`;

//# sourceMappingURL=styled.js.map